import socketIOClient from "socket.io-client";
import Api from "../../customlib/Api";
import Global from "../../customlib/Global";

// Koneksi socket.io TERPISAH dari Global.getSocket() (dipakai fitur WA existing) — namespace
// /livechat ini attach langsung ke lotus-be-express, tidak bergantung pada App Profile/nomor WA.
let livechatSocket = null;

export function connectLivechatSocket() {
    if (livechatSocket) return livechatSocket;

    const baseUrl = Api.getLivechatSocketUrl();
    livechatSocket = socketIOClient(`${baseUrl}/livechat`, {
        auth: { agentToken: Global.get().be_express_token },
        transports: ["websocket", "polling"],
    });

    return livechatSocket;
}

export function disconnectLivechatSocket() {
    if (livechatSocket) {
        livechatSocket.disconnect();
        livechatSocket = null;
    }
}
